<template>
  <div class="bottom-safe" :style="{ 'padding-top': offsetHeight + 'px' }">
    <van-nav-bar
      v-if="fullPathToCategory"
      :fixed="true"
      :title="title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      ref="navBar"
    />
    <EpisodeList
      :slug="slug"
      :category-id="category.id"
      :limit="0"
      @got-episodes-count="gotEpisodesCount"
    />
  </div>
</template>

<script>
  import store from '../store/index'
  import Vue from 'vue'
  import { NavBar } from 'vant'
  import EpisodeList from './episode-list.vue'
  Vue.use(NavBar)

  export default {
    name: "CategoryDetail",
    components: {
      EpisodeList
    },
    data () {
      return {
        title: '',
        fullPathToCategory: '',
        category: {
          id: null,
          show: ''
        },
        offsetHeight: 0
      }
    },
    computed: {
      slug () {
        return this.category.show
      }
    },
    methods: {
      onClickLeft() {
        store.commit("clearPrevFullPath")
        this.$router.replace({
          path: this.fullPathToCategory
        })
      },
      loadCategory () {
        let that = this
        let categoryId = this.$route.params.categoryId
        that.$api.category.detail(categoryId).then(res => {
          that.category = res.data
          that.title = res.data.label
        })
      },
      gotEpisodesCount (count) {
        window.console.log(count)
        // this.title = `${this.title} ${count} 期`
      }
    },
    watch: {
      episode (value) {
        // value: episode
        if (value.audios.length > 0) {
          this.hasAudios = true
        } else {
          this.hasAudios = false
        }
        if (value.videos.length > 0) {
          this.hasVideos = true
        } else {
          this.hasVideos = false
        }
      }
    },
    mounted () {
      let that = this
      if (store.state.fullPathToCategory) {
        that.fullPathToCategory = store.state.fullPathToCategory
        if (store.state.fullPathToCategory) {
          that.$nextTick(function() {
            that.offsetHeight = that.$refs.navBar.$el.offsetHeight
          })
        }
      }
      that.loadCategory()
    }
  }
</script>

<style lang="css" scoped>
  .block{
    margin-top: 10px;
  }
</style>
